interface NavAttributes {
  [propName: string]: any;
}

interface NavWrapper {
  attributes: NavAttributes;
  element: string;
}

interface NavBadge {
  text: string;
  variant: string;
}

interface NavLabel {
  class?: string;
  variant: string;
}

export interface NavData {
  name?: string;
  url?: string;
  icon?: string;
  badge?: NavBadge;
  title?: boolean;
  children?: NavData[];
  variant?: string;
  attributes?: NavAttributes;
  divider?: boolean;
  class?: string;
  label?: NavLabel;
  wrapper?: NavWrapper;
}

export const enableStahunAnggaranPrevious = localStorage.getItem('enableStahunAnggaranPrevious');
const tahunAnggaranPrevious = localStorage.getItem('tahunAnggaranPrevious') || (new Date().getFullYear() - 1).toString();
const tahunAnggaran = localStorage.getItem('tahunAnggaran') || new Date().getFullYear().toString();
const tahunAnggaranNext = localStorage.getItem('tahunAnggaranNext') || (new Date().getFullYear() + 1).toString();

export function generateNavItemsOtorPejabatTeknis(tahunAnggaran: any): NavData {
  const baseUrl = `/${tahunAnggaran}`;
  return {
    name: tahunAnggaran,
    url: baseUrl,
    icon: `icon-institution`,
    children: [
      {
        name: `Monitoring`,
        url: `${baseUrl}/monitoring`,
        icon: `icon-folders`,
      },
      {
        name: `Ikhtisar RBA`,
        url: `${baseUrl}/dashboard`,
        icon: `icon-file`,
      },
      {
        name: `Pendapatan`,
        url: `${baseUrl}/pendapatan`,
        icon: `icon-walleto`,
      },
      {
        name: `Belanja`,
        url: `${baseUrl}/belanja`,
        icon: `icon-shopping-cart`,
      },
      {
        name: `Pembiayaan`,
        url: `${baseUrl}/pembiayaan`,
        icon: `icon-cardo`,
      },
      {
        name: `Laporan`,
        url: `${baseUrl}/laporan`,
        icon: `icon-documentto`,
      },
      {
        name: `Ambang Batas`,
        url: `${baseUrl}/ambang-batas`,
        icon: `icon-file-edit`
      },
      // {
      //   name: `Sumber Dana`,
      //   url: `${baseUrl}/sumber-dana`,
      //   icon: `icon-card-receive`
      // },
      {
        name: `Forward Estimate`,
        url: `${baseUrl}/forward-estimate`,
        icon: `icon-card-receive`
      },
    ]
  };
}

function generateNavItemsOtorPejabatTeknisPerubahan(tahunAnggaran: any): NavData {
  const baseUrl = `/${tahunAnggaran}-perubahan`;
  return {
    name: tahunAnggaran + ' Perubahan',
    url: baseUrl,
    icon: `icon-institution`,
    children: [
      {
        name: `Monitoring`,
        url: `${baseUrl}/monitoring`,
        icon: `icon-folders`,
      },
      {
        name: `Ikhtisar RBA`,
        url: `${baseUrl}/dashboard`,
        icon: `icon-file`,
      },
      {
        name: `Pendapatan`,
        url: `${baseUrl}/pendapatan`,
        icon: `icon-walleto`,
      },
      {
        name: `Belanja`,
        url: `${baseUrl}/belanja`,
        icon: `icon-shopping-cart`,
      },
      {
        name: `Pembiayaan`,
        url: `${baseUrl}/pembiayaan`,
        icon: `icon-cardo`,
      },
      {
        name: `Laporan`,
        url: `${baseUrl}/laporan`,
        icon: `icon-documentto`,
      },
      {
        name: `Ambang Batas`,
        url: `${baseUrl}/ambang-batas`,
        icon: `icon-file-edit`
      },
      // {
      //   name: `Sumber Dana`,
      //   url: `${baseUrl}/sumber-dana`,
      //   icon: `icon-card-receive`
      // },
      {
        name: `Forward Estimate`,
        url: `${baseUrl}/forward-estimate`,
        icon: `icon-card-receive`
      },
    ]
  };
}

function generateNavItemsOtorPejabatKeuangan(tahunAnggaran: any): NavData {
  const baseUrl = `/${tahunAnggaran}`;
  return {
    name: tahunAnggaran,
    url: baseUrl,
    icon: `icon-institution`,
    children: [
      {
        name: `Monitoring`,
        url: `${baseUrl}/monitoring`,
        icon: `icon-folders`,
      },
      {
        name: `Ikhtisar RBA`,
        url: `${baseUrl}/dashboard`,
        icon: `icon-file`,
      },
      {
        name: `Pendapatan`,
        url: `${baseUrl}/pendapatan`,
        icon: `icon-walleto`,
      },
      {
        name: `Belanja`,
        url: `${baseUrl}/belanja`,
        icon: `icon-shopping-cart`,
      },
      {
        name: `Pembiayaan`,
        url: `${baseUrl}/pembiayaan`,
        icon: `icon-cardo`,
      },
      {
        name: `Laporan`,
        url: `${baseUrl}/laporan`,
        icon: `icon-documentto`,
      },
    ]
  };
}

function generateNavItemsOtorPemimpinBLUD(tahunAnggaran: any): NavData {
  const baseUrl = `/${tahunAnggaran}`;
  return {
    name: tahunAnggaran,
    url: baseUrl,
    icon: `icon-institution`,
    children: [
      {
        name: `Monitoring`,
        url: `${baseUrl}/monitoring`,
        icon: `icon-folders`,
      },
      {
        name: `Ikhtisar RBA`,
        url: `${baseUrl}/dashboard`,
        icon: `icon-file`,
      },
      {
        name: `Pendapatan`,
        url: `${baseUrl}/pendapatan`,
        icon: `icon-walleto`,
      },
      {
        name: `Belanja`,
        url: `${baseUrl}/belanja`,
        icon: `icon-shopping-cart`,
      },
      {
        name: `Pembiayaan`,
        url: `${baseUrl}/pembiayaan`,
        icon: `icon-cardo`,
      },
      {
        name: `Laporan`,
        url: `${baseUrl}/laporan`,
        icon: `icon-documentto`,
      },
      {
        name: `Pengguna`,
        url: `${baseUrl}/pengguna-skpd`,
        icon: `icon-user`,
      }
    ]
  };
}

function generateNavItemsOtorPemimpinBLUDFase3(tahunAnggaran: any): NavData {
  const baseUrl = `/${tahunAnggaran}`;
  return {
    name: tahunAnggaran,
    url: baseUrl,
    icon: `icon-institution`,
    children: [
      {
        name: `Monitoring`,
        url: `${baseUrl}/monitoring`,
        icon: `icon-folders`,
      },
      {
        name: `Ikhtisar RBA`,
        url: `${baseUrl}/dashboard`,
        icon: `icon-file`,
      },
      {
        name: `Fase`,
        url: `${baseUrl}/konfirmasi-fase`,
        icon: `icon-docs`
      },
      {
        name: `Pendapatan`,
        url: `${baseUrl}/pendapatan`,
        icon: `icon-walleto`,
      },
      {
        name: `Belanja`,
        url: `${baseUrl}/belanja`,
        icon: `icon-shopping-cart`, 
      },
      {
        name: `Pembiayaan`,
        url: `${baseUrl}/pembiayaan`,
        icon: `icon-cardo`,
      },
      {
        name: `Laporan`,
        url: `${baseUrl}/laporan`,
        icon: `icon-documentto`,
      },
      {
        name: `Pengguna`,
        url: `${baseUrl}/pengguna-skpd`,
        icon: `icon-user`,
      }
    ]
  };
}

function generateNavItemsOtorDinasTeknis(tahunAnggaran: any): NavData {
  const baseUrl = `/${tahunAnggaran}`;
  return {
    name: tahunAnggaran,
    url: baseUrl,
    icon: `icon-institution`,
    children: [
      {
        name: `SKPD`,
        url: `${baseUrl}/skpd`,
        icon: `icon-file`,
      }
    ]
  };
}

  function generateNavItemsOtorTAPD(tahunAnggaran: any): NavData {
    const baseUrl = `/${tahunAnggaran}`;
    return {
      name: tahunAnggaran,
      url: baseUrl,
      icon: `icon-institution`,
      children: [
        {
          name: `SKPD`,
          url: `${baseUrl}/skpd`,
          icon: `icon-file`,
        },
        {
          name: `Fase`,
          url: `${baseUrl}/fase`,
          icon: `icon-file`,
        },
        {
          name: `Batas Inputan`,
          url: `${baseUrl}/batas-inputan`,
          icon: `icon-file`,
        },
      ]
    };
  }

function generateNavItemsOtorAdmin(tahunAnggaran: any): NavData {
  const baseUrl = `/${tahunAnggaran}`;
  return {
    name: tahunAnggaran,
    url: baseUrl,
    icon: `icon-institution`,
    children: [
      {
        name: `SKPD`,
        url: `${baseUrl}/skpd`,
        icon: `icon-file`,
      }
    ]
  };
}

function generateNavItemsOtorSuperAdmin(tahunAnggaran: any): NavData {
  const baseUrl = `/${tahunAnggaran}`;
  return {
    name: tahunAnggaran,
    url: baseUrl,
    icon: `icon-institution`,
    children: [
      {
        name: `SKPD`,
        url: `${baseUrl}/skpd`,
        icon: `icon-file`,
      }
    ]
  };
}

export const navItemsOtorPejabatTeknis: NavData[] = [
  enableStahunAnggaranPrevious === 'true' ? generateNavItemsOtorPejabatTeknis(tahunAnggaranPrevious) : null,
  generateNavItemsOtorPejabatTeknisPerubahan(tahunAnggaran),
  generateNavItemsOtorPejabatTeknis(tahunAnggaran),
  generateNavItemsOtorPejabatTeknis(tahunAnggaranNext),
].filter(item => item !== null);

export const navItemsOtorPejabatKeuangan: NavData[] = [
  enableStahunAnggaranPrevious === 'true' ? generateNavItemsOtorPejabatKeuangan(tahunAnggaranPrevious) : null,
  generateNavItemsOtorPejabatKeuangan(tahunAnggaran),
  generateNavItemsOtorPejabatKeuangan(tahunAnggaranNext),
].filter(item => item !== null);

export const navItemsOtorPemimpinBLUD: NavData[] = [
  enableStahunAnggaranPrevious === 'true' ? generateNavItemsOtorPemimpinBLUD(tahunAnggaranPrevious) : null,
  generateNavItemsOtorPemimpinBLUD(tahunAnggaran),
  generateNavItemsOtorPemimpinBLUD(tahunAnggaranNext),
].filter(item => item !== null);

export const navItemsOtorPemimpinBLUDFase3: NavData[] = [
  enableStahunAnggaranPrevious === 'true' ? generateNavItemsOtorPemimpinBLUDFase3(tahunAnggaranPrevious) : null,
  generateNavItemsOtorPemimpinBLUDFase3(tahunAnggaran),
  generateNavItemsOtorPemimpinBLUDFase3(tahunAnggaranNext),
].filter(item => item !== null);

export const navItemsOtorDinasTeknis: NavData[] = [
  enableStahunAnggaranPrevious === 'true' ? generateNavItemsOtorDinasTeknis(tahunAnggaranPrevious) : null,
  generateNavItemsOtorDinasTeknis(tahunAnggaran),
  generateNavItemsOtorDinasTeknis(tahunAnggaranNext),
].filter(item => item !== null);

export const navItemsOtorTAPD: NavData[] = [
  {
    name: `Pengguna`,
    url: `/${tahunAnggaran}/pengguna`,
    icon: `icon-user`,
  },
  enableStahunAnggaranPrevious === 'true' ? generateNavItemsOtorTAPD(tahunAnggaranPrevious) : null,
  generateNavItemsOtorTAPD(tahunAnggaran),
  generateNavItemsOtorTAPD(tahunAnggaranNext),
].filter(item => item !== null);

export const navItemsOtorAdmin: NavData[] = [
  enableStahunAnggaranPrevious === 'true' ? generateNavItemsOtorAdmin(tahunAnggaranPrevious) : null,
  generateNavItemsOtorAdmin(tahunAnggaran),
  generateNavItemsOtorAdmin(tahunAnggaranNext),
].filter(item => item !== null);

export const navItemsOtorSuperAdmin: NavData[] = [
  enableStahunAnggaranPrevious === 'true' ? generateNavItemsOtorSuperAdmin(tahunAnggaranPrevious) : null,
  generateNavItemsOtorSuperAdmin(tahunAnggaran),
  generateNavItemsOtorSuperAdmin(tahunAnggaranNext),
].filter(item => item !== null);

export const navItems: NavData[] = [
  {
    name: `Monitoring`,
    url: `/${tahunAnggaran}/monitoring`,
    icon: `icon-folders`,
  },
  {
    name: `Ikhtisar RBA`,
    url: `/${tahunAnggaran}/dashboard`,
    icon: `icon-file`,
  },
  {
    name: `Pendapatan`,
    url: `/${tahunAnggaran}/pendapatan`,
    icon: `icon-walleto`,
  },
  {
    name: `Belanja`,
    url: `/${tahunAnggaran}/belanja`,
    icon: `icon-shopping-cart`,
  },
  {
    name: `Pembiayaan`,
    url: `/${tahunAnggaran}/pembiayaan`,
    icon: `icon-walleto`,
  },
  {
    name: `Laporan`,
    url: `/${tahunAnggaran}/laporan`,
    icon: `icon-documentto`,
  },
  {
    name: `Ambang Batas`,
    url: `/${tahunAnggaran}/ambang-batas`,
    icon: `icon-file-edit`
  }
];
